const messages = {
  en: {
    title: 'Something went wrong...',
    subtitle: 'The server did not provide the necessary data. Please refresh the page.',
    button: 'Refresh the Page',
  },
  he: {
    title: 'Something went wrong...',
    subtitle: 'The server did not provide the necessary data. Please refresh the page.',
    button: 'Refresh the Page',
  },
  es: {
    title: 'Something went wrong...',
    subtitle: 'The server did not provide the necessary data. Please refresh the page.',
    button: 'Refresh the Page',
  },
  it: {
    title: 'Something went wrong...',
    subtitle: 'The server did not provide the necessary data. Please refresh the page.',
    button: 'Refresh the Page',
  },
  fr: {
    title: 'Something went wrong...',
    subtitle: 'The server did not provide the necessary data. Please refresh the page.',
    button: 'Refresh the Page',
  },
};

export default messages;
